import Img from "./img";
import styled from "styled-components";
import shared from "../data/js/shared";

const { spinner1, spinner2 } = shared.post;
const SpinnerStyles = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -122px 0 0 -122px;
    border-radius: 20px;
    padding: 20px;
    z-index: 9;
    width: 244px;
    height: 244px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);

    .spinner__icon {
        height: 160px;
        overflow: hidden;
        top: -20px;
        position: relative;
    }

    .spinner__text {
        text-align: center;
        font-size: 2rem;
        position: relative;
        display: block;
    }
`
const Spinner = () => {
    return (
       <SpinnerStyles className="same-color">
          <div className="spinner__text">{spinner1}</div>
          <div className="spinner__icon">
            <Img src="/images/svg/spinner.svg" />
          </div>
          <div className="spinner__text">{spinner2}</div>
        </SpinnerStyles> 
    )
}
export default Spinner;